import { Befehl28 } from '../../../models'
import { BefehlAuftrag_28_10Dto, BefehlAuftrag_28_20Dto } from '../../../dtos'
import {
  Befehl28FormData,
  Befehl28FormSchema
} from './schema/befehl28-form.schema'
import {
  createField,
  findAuftragByKennung,
  hasAuftrag
} from '../converter-utils'
import { Befehl28DataDto } from '../../../dtos/befehl-28-dto'

export const convertModelToBefehl28FormData = (
  befehl?: Befehl28
): Befehl28FormData => {
  const formData = Befehl28FormSchema.parse({})

  if (!befehl?.auftraege || befehl.auftraege.length === 0) {
    return formData
  }

  const auftrag28_10 = findAuftragByKennung(
    befehl.auftraege,
    '28.10'
  ) as BefehlAuftrag_28_10Dto
  const auftrag28_20 = findAuftragByKennung(
    befehl.auftraege,
    '28.20'
  ) as BefehlAuftrag_28_20Dto

  const has28_10 = hasAuftrag(befehl.auftraege, '28.10')
  const has28_20 = hasAuftrag(befehl.auftraege, '28.20')

  formData.auftrag_28_10.enabled = has28_10
  formData.auftrag_28_10.etcsLevel =
    auftrag28_10?.felder?.[0]?.werte?.etcsLevel || ''

  formData.auftrag_28_20.enabled = has28_20
  formData.auftrag_28_20.etcsBetriebsart =
    auftrag28_20?.felder?.[0]?.werte?.etcsBetriebsart || ''

  return formData
}

export const convertBefehl28FormDataToModel = (
  formData: Befehl28FormData,
  frontendId: string
): Befehl28 => {
  const auftraege: Befehl28DataDto = []

  if (formData.auftrag_28_10?.enabled) {
    auftraege.push({
      kennung: '28.10',
      felder: [
        createField('28.11', {
          etcsLevel: formData.auftrag_28_10?.etcsLevel || ''
        })
      ]
    } as BefehlAuftrag_28_10Dto)
  }

  if (formData.auftrag_28_20?.enabled) {
    auftraege.push({
      kennung: '28.20',
      felder: [
        createField('28.21', {
          etcsBetriebsart: formData.auftrag_28_20?.etcsBetriebsart || ''
        })
      ]
    } as BefehlAuftrag_28_20Dto)
  }

  return {
    kennung: '28',
    frontendId,
    auftraege
  }
}
